import React from "react";

import { useTranslation } from "utils";

import { Button, Icon } from "components";

type FarmMapEmptyBarProps = {
  /** false for programs without field management: the prompt stays, the upload button goes */
  canAddFields: boolean;
  onAddFields: () => void;
};

export const FarmMapEmptyBar = ({ canAddFields, onAddFields }: FarmMapEmptyBarProps) => {
  const { t } = useTranslation("home");

  return (
    <div className="farm-map-bar farm-map-empty-bar" data-testid="farm-map-empty-bar">
      <div className="farm-map-empty-row">
        <span className="farm-map-empty-icon">
          <Icon iconName="klim/field" size="s" />
        </span>
        <span className="farm-map-empty-text">{t("farmMap.noFields.text")}</span>
      </div>
      {canAddFields ? (
        <Button dataTestId="farm-map-add-fields" type="primary" block onClick={onAddFields}>
          {t("farmMap.noFields.addFields")}
        </Button>
      ) : null}
    </div>
  );
};

/** The field list failed to load: the bar says so instead of inviting an upload the farmer may not need. */
export const FarmMapUnavailableBar = () => {
  const { t } = useTranslation("home");

  return (
    <div className="farm-map-bar farm-map-empty-bar" data-testid="farm-map-unavailable-bar">
      <div className="farm-map-empty-row">
        <span className="farm-map-empty-icon">
          <Icon iconName="klim/field" size="s" />
        </span>
        <span className="farm-map-empty-text">{t("farmMap.fieldsUnavailable")}</span>
      </div>
    </div>
  );
};
